module.exports = __webpack_public_path__ + "img/card3.df33c621.png";